import { QueryClient } from '@tanstack/react-query'
import { type AxiosError } from 'axios'

import type { DefaultOptions, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes — keep data navigable between routes
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: (failureCount, error) => {
      const status = (error as AxiosError).response?.status
      if (status && status >= 400 && status < 500) {return false}
      return failureCount < 2
    },
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  },
  mutations: {
    retry: false,
  },
}

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
})

export type ExtractFnReturnType<FnType extends (...args: unknown[]) => unknown> = Awaited<
  ReturnType<FnType>
>

export type QueryConfig<T extends (...args: unknown[]) => unknown> = Omit<
  UseQueryOptions<ExtractFnReturnType<T>, AxiosError>,
  'queryKey' | 'queryFn'
>

export type MutationConfig<T extends (...args: unknown[]) => unknown> = UseMutationOptions<
  ExtractFnReturnType<T>,
  AxiosError,
  Parameters<T>[0]
>
